// extracted by mini-css-extract-plugin
export var md = "_4a-4";
export var semantic = "_4a-5";
export var sm = "_4a-3";
export var text = "_4a-6";
export var toggleInput = "_4a-0";
export var toggleSwitch = "_4a-1";
export var xs = "_4a-2";